"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDropMnemonicId = void 0;
const cronJobPayloadSchema_1 = __importDefault(require("root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema"));
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
exports.updateDropMnemonicId = {
    [endpointIds_1.UPDATE_DROP_MNEMONIC_ID]: {
        cronJobPayloadSchema: cronJobPayloadSchema_1.default,
    },
};
